const isUps = (organizationName?: string) => (
  organizationName?.toLowerCase() === "ups"
);

export default isUps;
